// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppPricingReportManageSubscription {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get Cpp Price List
  public getManageSubscriptionList(reportTypeId) {
    return this.networkService.getRequest(this.configService.getPricingReportManageSubscriptionList() + '?reportTypeId=' + reportTypeId);
  }

  public addUpdateSubscription(data) {
    return this.networkService.postRequest(this.configService.addUpdatePricingReportSubscription(), data);
  }

  public isValidForSubscription() {
    return this.networkService.getRequest(this.configService.isValidForSubscription());
  }
}
